import Clarity from '@microsoft/clarity'

type ErrorScope = 'root' | 'request-step'

/**
 * Envia um erro de render para o Clarity e para o console.
 *
 * Sem isso, uma exceção em render/effect apenas desmonta a árvore e o
 * incidente fica invisível: não há mensagem, log ou sessão filtrável.
 */
export function reportRenderError(
  error: unknown,
  scope: ErrorScope,
  componentStack?: string | null
) {
  const message = error instanceof Error ? error.message : String(error)

  console.error(`[render-crash:${scope}]`, error, componentStack)

  try {
    Clarity.setTag('render-crash', scope)
    Clarity.setTag('render-crash-message', message.slice(0, 250))
    Clarity.event(`render-crash-${scope}`)
    Clarity.upgrade('render-crash')
  } catch {
  }
}
